import { Subject } from 'rxjs';

export const StepperUtil = {
  stepClick$: new Subject<any>(),
  dispatchStepClickEvent: function(data) {
    this.stepClick$.next(data);
  },
};
